import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router'

/**
 * Faz o botão "voltar" fechar um estado transitório (modal/drawer/etc.) via `onDismiss`, em vez de navegar.
 *
 * Não suporta instâncias concorrentes: com duas ativas ao mesmo tempo, um único "voltar" dispara o `onDismiss` das duas.
 */
export function useDismissOnBackButton(active: boolean, onDismiss: () => void) {
  const history = useHistory()
  const onDismissRef = useRef(onDismiss)

  useEffect(() => {
    onDismissRef.current = onDismiss
  })

  useEffect(() => {
    if (!active) {
      return
    }

    history.push(history.location.pathname + history.location.search, { dismissOnBack: true })

    const unlisten = history.listen((_location, action) => {
      if (action === 'POP') {
        onDismissRef.current()
      }
    })

    return () => {
      unlisten()
      if ((history.location.state as { dismissOnBack?: boolean })?.dismissOnBack) {
        history.goBack()
      }
    }
  }, [active, history])
}
